import { DSTooltip, useToast } from '@repo/design-system/index'
import { QIcon_caf_pin_active, QIcon_caf_pin_inactive } from '@repo/icons/index'
import { useQueryClient } from '@tanstack/react-query'
import { useRouter } from 'next/router'
import { useState } from 'react'
import { toast } from 'react-toastify'
import Cookies from 'universal-cookie'
import { useCafEditTooltipV4, useCafPinnedV5, useCafShowTooltipV4 } from '../../../../modules/apis/webview/caf'
import useIsWebview from '../../../../modules/hooks/common/useIsWebview'
import { n_caf } from '../../../../modules/i18n/strings/auto/wording_webview'
import useTranslation from '../../../../modules/i18n/useTranslation'
import { COLORS } from '../../../../modules/vars'

const PinIcon = ({ tag, isActive, tooltipDisabled = false, onSettled = null, ...iconProps }) => {
  const cookies = new Cookies()
  const [isPinnned, setIsPinned] = useState(isActive)
  const { t } = useTranslation()
  const { mutate } = useCafPinnedV5()
  const { toastSuccess } = useToast()
  const queryClient = useQueryClient()
  const isWebview = useIsWebview()
  const router = useRouter()
  const lessonId = router.query?.lessonId
  const { data } = useCafShowTooltipV4('show_tooltip')
  const [isOpen, setIsOpen] = useState(data?.value === null ? true : false)
  const { mutate: editTooltip } = useCafEditTooltipV4()

  const handleClose = () => {
    // tooltip close query
    editTooltip(
      { key: 'show_tooltip', value: !isOpen },
      {
        onSuccess: () => {
          setIsOpen(false)
        },
      }
    )
  }

  const togglePin = () => {
    console.log('isOpen 값: ', isOpen)
    setIsPinned(!isPinnned)
    mutate(
      { tag, active: !isPinnned },
      {
        onSuccess: () => {
          if (!isPinnned) {
            isWebview ? toastSuccess(t(n_caf.highlight_list_edit.toast1)) : toast(t(n_caf.highlight_list_edit.toast1))
          } else {
            isWebview ? toastSuccess(t(n_caf.highlight_list_edit.toast2)) : toast(t(n_caf.highlight_list_edit.toast2))
          }
          if (isOpen) {
            // tooltip 이 열려있는 경우에만 close query 를 실행
            handleClose()
          }
        },
        onSettled: () => {
          onSettled && onSettled()
        },
      }
    )
  }

  return (
    <div className="cursor-pointer">
      {!isOpen ? (
        isPinnned ? (
          <QIcon_caf_pin_active {...iconProps} fill={COLORS.PURPLE500} onClick={togglePin} />
        ) : (
          <QIcon_caf_pin_inactive {...iconProps} fill={COLORS.WHITE} onClick={togglePin} />
        )
      ) : (
        <DSTooltip
          hasCloseButton
          place="bottom"
          isMultiline={false}
          triggerComponent={
            isPinnned ? (
              <QIcon_caf_pin_active {...iconProps} fill={COLORS.PURPLE500} onClick={togglePin} />
            ) : (
              <QIcon_caf_pin_inactive {...iconProps} fill={COLORS.WHITE} onClick={togglePin} />
            )
          }
          contentComponent={t(n_caf.overview.tophighlights_info)}
          onClose={handleClose}
        />
      )}
    </div>
  )
}
export default PinIcon
